import { render, staticRenderFns } from "./UpgradeClock.vue?vue&type=template&id=b5030500&scoped=true"
import script from "./UpgradeClock.vue?vue&type=script&lang=js"
export * from "./UpgradeClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5030500",
  null
  
)

export default component.exports